import React, { useState } from 'react'
import { ResultCard } from '@/components/donation'
import { buildResultItem } from '@/utils'
import { SubSection, StyledDemoGrid, DemoComponent } from '../styled.jsx'

export const ResultCardSection = () => {
  const [selectedId, setSelectedId] = useState(null)

  const sampleItems = [
    {
      id: 'a',
      name: 'Downtown Donation Center',
      date: 'Fri, Sep 26',
      sponsored_by: 'Acme Corp',
      distance: '3.2 mi',
      hours: '8:00 AM – 4:00 PM',
      address: '123 Main St, Springfield',
      available_slots_count: 12,
      title: 'About Downtown Donation Center',
      description:
        'Conveniently located in the heart of the city with ample parking and friendly staff.',
      phone_number: '(555) 123-4567',
      website: 'https://example.org',
    },
    {
      id: 'b',
      name: 'Riverside Community Hall',
      date: 'Sat, Sep 27',
      sponsored_by: 'Blue River Foundation',
      secondary_name: 'Blood Center',
      hours: '9:00 AM – 2:00 PM',
      address: '78 Riverside Ave, Springfield',
      available_slots_count: 5,
      title: 'About Riverside Community Hall',
      description: [
        'A spacious venue by the river, perfect for weekend donors.',
        'Snacks and refreshments provided.',
      ],
      phone_number: '(555) 987-6543',
      website: 'https://river.org',
    },
  ]

  return (
    <SubSection
      title='Result Card'
      description='Selectable search result card with description dialog.'
    >
      <StyledDemoGrid sx={{ flexDirection: 'column', alignItems: 'stretch' }}>
        {sampleItems.map(item => (
          <DemoComponent
            key={item.id}
            label={selectedId === item.id ? 'selected' : 'not selected'}
            component={
              <ResultCard
                item={buildResultItem(item)}
                selected={selectedId === item.id}
                onSelect={next => setSelectedId(next ? item.id : null)}
              />
            }
          />
        ))}
      </StyledDemoGrid>
    </SubSection>
  )
}
